import { CommonModule } from "@angular/common";
import { Component, inject, OnInit } from "@angular/core";
import {
  FormBuilder,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from "@angular/forms";
import { lastValueFrom } from "rxjs";
import { UserService } from "src/app/services/api/user.service";
import { SweetAlertService } from "src/app/services/sweet-alert-service/sweet-alert.service";
import { ToastService } from "src/app/services/toast-service/toast.service";
import { SharedModule } from "src/shared/shared.module";
import { LabelMode } from "src/utils/label-mode.enum";
import { MustMatch } from "src/utils/must-match.validator";
import { SetError } from "src/utils/set-error.validator";
import { AuthService } from "../../auth";
import { TranslateModule, TranslateService } from "@ngx-translate/core";

@Component({
  selector: "app-user-password",
  imports: [
    CommonModule,
    SharedModule,
    ReactiveFormsModule,
    FormsModule,
    TranslateModule,
  ],
  templateUrl: "./user-password.component.html",
  styleUrl: "./user-password.component.scss",
})
export class UserPasswordComponent implements OnInit {
  #fb = inject(FormBuilder);
  #swalService = inject(SweetAlertService);
  #userService = inject(UserService);
  #authService = inject(AuthService);
  #toastService = inject(ToastService);
  #translate = inject(TranslateService);

  form: FormGroup;
  error: any;
  LabelMode = LabelMode;

  currentUser = this.#authService.currentUser()?.user;

  ngOnInit(): void {
    this.buildForm();
  }

  buildForm() {
    this.form = this.#fb.group(
      {
        old_password: [null, Validators.required],
        new_password: [null, Validators.required],
        new_password_confirmation: [null, Validators.required],
      },
      { validators: [MustMatch("new_password", "new_password_confirmation")] }
    );
  }

  async submit() {
    this.error = {};
    if (this.form.invalid) {
      this.error = SetError(this.form);
      return;
    }
    let payload = this.form.getRawValue();
    await this.#swalService.swalConfirmation();
    try {
      const changePassword = await lastValueFrom(
        this.#userService.changePassword(payload)
      );
      this.#toastService.toastSuccess(
        this.#translate.instant("VALIDATOR.CHANGE_PASSWORD_SUCCESS")
      );
      this.form.reset();
    } catch (error: any) {
      this.showError(error.error.code);
    }
  }
  async resetRequest() {
    // this.notifierService.notify('default', 'ระบบยังไม่พร้อมใช้งาน');
    await this.#swalService.swalConfirmation();

    const email = this.currentUser?.email;
    try {
      this.#swalService.swalLoading();
      const reset = await lastValueFrom(
        this.#userService.requestToReset(email)
      );
      this.#swalService.swalClose();
      this.#swalService.swalSuccess(
        this.#translate.instant("APP.SEND_EMAIL_DESC"),
        " "
      );
    } catch (error: any) {
      this.showError(error.error.error);
      // this.#toastService.toastError(error.error.error);
    }
  }

  showError(code: string): void {
    switch (code) {
      case "CP03":
        this.#toastService.toastError(
          this.#translate.instant("VALIDATOR.CHANGE_PASSWORD_DUPLICATED")
        );
        break;
      case "CP04":
        this.#toastService.toastError(
          this.#translate.instant("VALIDATOR.CHANGE_PASSWORD_INVALID")
        );
        break;
      default:
        this.#toastService.toastError(
          this.#translate.instant("VALIDATOR.CHANGE_PASSWORD_ERROR")
        );
    }
  }
}
